export type IndexedMap<K extends string | number | symbol, V> = {
  [k in K]: V;
};

export class MapUtils {
  static keys<K extends string | number | symbol, V>(map: IndexedMap<K, V>): Array<keyof IndexedMap<K, V>> {
    return Object.keys(map) as Array<keyof IndexedMap<K, V>>;
  }

  static values<K extends string | number | symbol, V>(
    map: IndexedMap<K, V>
  ): Array<IndexedMap<K, V>[keyof IndexedMap<K, V>]> {
    return MapUtils.keys(map).map((k: K) => map[k]);
  }

  static keyValues<K extends string | number | symbol, V>(
    map: IndexedMap<K, V>
  ): Array<[keyof IndexedMap<K, V>, IndexedMap<K, V>[keyof IndexedMap<K, V>]]> {
    return MapUtils.keys(map).map((k) => [k, map[k]]);
  }
}
